module.exports = __webpack_public_path__ + "img/fietsmerin-video-3.193b3bd0.jpg";